import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "./Components/Pages/NotFound/NotFound";
import Header from "./Components/Molecules/Header/Header";
import Footer from "./Components/Molecules/Footer/Footer";
import Home from "./Components/Pages/Home/Home2"
import About from "./Components/Pages/About/About"
import Contact from "./Components/Pages/Contact/Contact"

import "./Components/Assets/dist/css/style.min.css"
import "./Components/Assets/dist/css/bootstrap.min.css"
import "./Components/Assets/dist/css/meanmenu.css"
import "./Components/Assets/dist/css/animate.min.css"
import "./Components/Assets/dist/css/magnific-popup.css"
import "./Components/Assets/dist/css/fontawesome-all.min.css"
import "./Components/Assets/dist/css/owl.carousel.min.css"
import "./Components/Assets/dist/css/owl.theme.default.min.css"
import "./Components/Assets/dist/css/scrolltop.css"
import "./Components/Assets/dist/css/default.css"
import "./Components/Assets/dist/css/wedget.css"
import "./Components/Assets/dist/css/style.min.css"
import "./Components/Assets/dist/css/responsive.css"
import "./Components/Assets/Sass/style.scss"
import ProductRange from "./Components/Pages/Product/ProductRange";

// Main App Component with Routing
const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/product-range" element={<ProductRange />} />


        <Route path="*" element={<NotFound />} /> {/* 404 Page */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
